export default __webpack_public_path__ + "static/luca-rossi-7016b6dd435dec927439e6f46fc2ca30.png";